import * as Yup from "yup";

export const gameValidationSchema = Yup.object().shape({
  title: Yup.string().trim().required("Title is required"),
  slug: Yup.string().trim().required("Slug is required"),
  mob_web_compatible: Yup.boolean().required(
    "Mobile/Web compatibility is required"
  ),
  category: Yup.string().trim().required("Type is required"),
  sub_category: Yup.string().trim().required("Sub Type is required"),
  orientation: Yup.string().trim().required("Orientation is required"),
  dimensions: Yup.string().trim().required("Dimensions are required"),
  language: Yup.string().trim().required("Language is required"),
  genres: Yup.array()
    .of(Yup.string().trim()),
  tags: Yup.array()
    .of(Yup.string().trim())
    .min(1, "At least one tag is required"),
  age_group: Yup.string().trim().required("Age group is required"),
  gender: Yup.string().required("Gender is required"),
  description: Yup.string()
    .trim()
    .required("Description is required")
    .max(1000, "Description cannot exceed 1000 characters"),
});

export const newGameValidationSchema = Yup.object().shape({
  title: Yup.string().trim().required("Title is required"),
  slug: Yup.string().trim().required("Slug is required"),
  mob_web_compatible: Yup.boolean().required(
    "Mobile/Web compatibility is required"
  ),
  category: Yup.string().trim().required("Type is required"),
  sub_category: Yup.string().trim().required("Sub Type is required"),
  orientation: Yup.string().trim().required("Orientation is required"),
  dimensions: Yup.string().trim().required("Dimensions are required"),
  language: Yup.string().trim().required("Language is required"),
  genres: Yup.array()
    .of(Yup.string().trim()),
  tags: Yup.array()
    .of(Yup.string().trim())
    .min(1, "At least one tag is required"),
  age_group: Yup.array()
  .of(Yup.string().trim())
  .min(1, "At least one option is required"),
  gender: Yup.array()
  .of(Yup.string().trim())
  .min(1, "At least one gender is required"),

  description: Yup.string()
    .trim()
    .max(1000, "Description cannot exceed 1000 characters"),
  instructions: Yup.string()
    .trim()
    .max(1000, "Instructions cannot exceed 1000 characters"),
  how_to_play: Yup.string()
    .trim()
    .max(1000, "How to play cannot exceed 1000 characters"),
  published_by: Yup.string().trim().required("Published by is required"),
  company: Yup.string().trim().required("Company name is required"),
  provider_id: Yup.string().trim().required("Game Provider is required"),
});

export const companyInfoValidations = Yup.object().shape({
  published_by: Yup.string().trim().required("Published by is required"),
  company: Yup.string().trim().required("Company name is required"),
});

export const GameApiValidation = Yup.object().shape({
  gameUrl: Yup.string().trim().required("Game Url is required."),
});
